import { IOtherFormulas } from 'components/formula-entry/modals/types';

export interface IFieldOption {
  name: string;
  displayName: string;
  productLine?: string;
}

export interface IStatusFieldOption extends IFieldOption {
  color: string;
}

export enum EOptionOwner {
  SHELL = 'shell',
  CUSTOMER = 'customer',
}

export enum ECycle {
  CONTRACT = 'contract',
  ANNUAL = 'annual',
  SEMI_ANNUAL = 'semi-annual',
  QUARTERLY = 'quarterly',
}

export interface IVolumeOption {
  description?: string;
  enabled: boolean; // Whether option will be included within evaluation
  owner: EOptionOwner; // Which party makes decision for when to exercise option
  volume?: number | null; // Change in volume for months where option is exercised
  count?: number; // How many times the option can be exercised in a cycle
  cycle: ECycle; // Period might be a better name, but we've over-used that word for other things
  notice?: number; // How many months owner must notify other party in advance of exercise

  basePrice: string | null;
  shellBatna: string | null;
  custBatna: string | null;
}

export interface IPrice {
  description: string;
  formula: string;
  costFreight: number;
  costReimbursed: number;
  costFixed?: number;
  costIncInventory?: number;
  costTransitDays?: number;
}

export interface IDealProduct {
  name: string;
  volume?: number;
  volumeUnit?: string;
  startDate?: Date | string;
  endDate?: Date | string;

  basePrice: IPrice;
  mainBatna?: IPrice;
  otherBatnas?: IPrice[];
  mfgCost?: string;

  capEnabled?: boolean;
  capValue?: string;
  capDescription?: string;
  floorEnabled?: boolean;
  floorValue?: string;
  floorDescription?: string;

  push?: { enabled: boolean; description: string };
  pull?: IVolumeOption;
  extension?: IVolumeOption;
  earlyTerm?: IVolumeOption;
  otherFormulas?: IOtherFormulas[];
  transportMode: string;
  incoTerm: string;
  otherSupply: string;
  priceSwitch: any;
}

export interface IFieldOptionState {
  error?: Error;
  loading: boolean;
  products?: IFieldOption[];
  productLines?: IFieldOption[];
  regions?: IFieldOption[];
  statuses?: IStatusFieldOption[];
  nonstandardRisks?: IFieldOption[];
  defaultTransportModes?: IFieldOption[];
  defaultIncoTerms?: IFieldOption[];
}

export const GET_FIELD_OPTIONS = 'GET_FIELD_OPTIONS';
export const GET_FIELD_OPTIONS_SUCCESS = 'GET_FIELD_OPTIONS_SUCCESS';
export const GET_FIELD_OPTIONS_FAIL = 'GET_FIELD_OPTIONS_FAIL';
export const DELETE_PRODUCT_FIELD = 'DELETE_PRODUCT_FIELD';
export const DELETE_PRODUCT_FIELD_SUCCESS = 'DELETE_PRODUCT_FIELD_SUCCESS';
export const DELETE_PRODUCT_FIELD_FAIL = 'DELETE_PRODUCT_FIELD_FAIL';

export enum EProductField {
  NAME = 'name',
  VOLUME = 'volume',
  VOLUME_UNIT = 'volumeUnit',
  START_DATE = 'startDate',
  END_DATE = 'endDate',

  BASE_PRICE = 'basePrice',
  MAIN_BATNA = 'mainBatna',
  OTHER_BATNAS = 'otherBatnas',
  MANUFACTURING_COST = 'mfgCost',

  CAP_ENABLED = 'capEnabled',
  CAP_VALUE = 'capValue',
  CAP_DESCRIPTION = 'capDescription',
  FLOOR_ENABLED = 'floorEnabled',
  FLOOR_VALUE = 'floorValue',
  FLOOR_DESCRIPTION = 'floorDescription',

  PUSH = 'push',
  PULL = 'pull',
  EXTENSION = 'extension',
  EARLY_TERMINATION = 'earlyTerm',
  INCOTERM = 'incoTerm',
  TRANSPORT_MODE = 'transportMode',
  OTHER_SUPPLY = 'otherSupply',
}

export enum EProductNestedField {
  DESCRIPTION = 'description',
  FORMULA = 'formula',
  COST_FREIGHT = 'costFreight',
  COST_FIXED = 'costFixed',
  COST_INVENTORY = 'costIncInventory',
  COST_TRANSIT_DAYS = 'costTransitDays',
  COST_REIMBURSED = 'costReimbursed',
}

export enum EContractTermOptionType {
  EARLY_TERMINATION = 'earlyTerm',
  EXTENSION = 'extension',
}

export const OFFER_TYPES = ['Essential', 'Exceptional'];

export interface IDeleteProductProps {
  products: IFieldOption[];
  productLines: IFieldOption[];
  regions: IFieldOption[];
  statuses: IStatusFieldOption[];
}
